export enum NavigationItem {
  Home = 'home',
  Search = 'search',
  Favorite = 'favorite',
  Summary = 'summary',
  Coverage = 'coverage',
  Context = 'context',
}

export enum ArticleUrlType {
  WEBSITE = 'website',
  ARTICLE = 'article',
  MUSIC = 'music',
  BOOK = 'book',
  PROFILE = 'profile',
}

export enum ARTICLE_DATE_TYPE {
  READ = 'read',
  PUBLISHED = 'published',
}

export enum NotificationType {
  PREMIUM_ARTICLE = 'premium_article',
  ONBOARDING_SUMMARY = 'onboarding_summary',
  ONBOARDING_COVERAGE = 'onboarding_coverage',
  ONBOARDING_CONTEXT = 'onboarding_context',
  ONBOARDING_FAVORITE = 'onboarding_favorite',
  ONBOARDING_HOME = 'onboarding_home',
}

// PAYPER-1123: estado interno del front para resumen/contexto mientras se
// genera contenido de forma asíncrona. NO son los valores crudos que manda el
// back (esos vienen en mayúscula y solo en los casos 202/503, sin campo
// `status` en el 200): la traducción a este enum se hace en `src/api/index.ts`
// a partir del código HTTP de la respuesta.
export enum GenerationStatus {
  PROCESSING = 'processing',
  ERROR = 'error',
  SUCCESS = 'success',
}
